import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "bg-black",
  id: "graph-component"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("link", {
  rel: "stylesheet",
  href: "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.9.1/font/bootstrap-icons.css"
}, null, -1)
const _hoisted_3 = { class: "bg-black" }
const _hoisted_4 = { class: "container flex justify-between pb-6" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { style: {"height":"100px","margin-top":"2rem"} }
const _hoisted_7 = ["innerHTML"]

import { Position } from '@unovis/ts'
import { VisAxis, VisCrosshair, VisStackedBar, VisTooltip, VisXYContainer } from '@unovis/vue'
import {ref, watch} from "vue";
import {PrisonerRecord} from "@/@types/types";
import {useChart} from "@/composables/useChart";

interface Props {
  records: PrisonerRecord[]
}

type FormatConfig = { format: any, color: string, icon: string, label: string  }
type TDataKeys = 'race' | 'gender' | 'ideology' | 'affiliation'
const height = 450


export default /*#__PURE__*/_defineComponent({
  __name: 'GraphComponent',
  props: {
    records: {}
  },
  setup(__props: any) {

const props = __props
const chartKeys = ['race', 'gender', 'ideology', 'affiliation']
const activeFilterKey = ref('race')
const { initialiseChartData, prepareData, generateLabels, transformData } = useChart()
initialiseChartData(props.records)

const preparedData = ref({
  race: prepareData('race'),
  gender: prepareData('gender'),
  ideology: prepareData('ideology'),
  affiliation: prepareData('affiliation'),
})

const labels = ref<any>(generateLabels(preparedData.value.race.series))
const chartData = ref<any>(transformData(preparedData.value.race))

watch(() => props.records, (newRecords, oldRecords) => {
  initialiseChartData(props.records)

  preparedData.value = {
    race: prepareData('race'),
    gender: prepareData('gender'),
    ideology: prepareData('ideology'),
    affiliation: prepareData('affiliation'),
  }

  const key = activeFilterKey.value ?? 'race'
   labels.value = generateLabels(preparedData.value[key].series)
   chartData.value = transformData(preparedData.value[key])
}, { deep: true });


function setChartData(key: TDataKeys) {
  activeFilterKey.value = key
  labels.value = generateLabels(preparedData.value[key].series)
  chartData.value = transformData(preparedData.value[key])
}


function getIcon(f: any): string {
  return `<span class="bi bi-${f.icon}" style="background:${f.color}; color:${f.color};margin:0 4px;position: relative;top:2px; height: 16px;overflow: hidden;border-radius: 3px;display: inline-block;"></span>${f.label}\t`
}

function tooltipTemplate(d: Record<string, number>): string {
  let total = 0
  Object.keys(d).forEach((key: string) => {
    if(key.toLocaleLowerCase() !== 'year') total += d[key]
  })

  console.log(d)
  const dataLegend = labels.value.filter((f: FormatConfig) => d[f.format] > 0)
      .reverse()
      .map((f: FormatConfig) => `<div><div style="margin-top: .35rem">${getIcon({ ...f, label: d[f.format] })} ${f.label}</div>`)
      .join('</div>')
  return `<div><b>${d.year} | Total ${total}</b> ${dataLegend}</div>`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(chartKeys, (key) => {
          return _createElementVNode("div", {
            onClick: () => setChartData(key as TDataKeys),
            key: key,
            class: _normalizeClass([activeFilterKey.value === key ? 'app-color-bg app-color-border-light' : 'border-white ', "text-white flex-grow text-center border capitalize px-6 py-4 cursor-pointer"])
          }, [
            _createElementVNode("span", null, _toDisplayString(key), 1)
          ], 10, _hoisted_5)
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labels.value, (l, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (index < 10)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "mr-3 mb-3 text-white",
                innerHTML: getIcon(l)
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ]),
    _createVNode(_unref(VisXYContainer), {
      data: chartData.value,
      height: height
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(VisStackedBar), {
          barPadding: 0.05,
          x: (d) => d.year,
          y: labels.value.map((l) => (d) => d[l.format])
        }, null, 8, ["x", "y"]),
        _createVNode(_unref(VisCrosshair), { template: tooltipTemplate }),
        _createVNode(_unref(VisTooltip), {
          verticalShift: height,
          horizontalPlacement: _unref(Position).Center
        }, null, 8, ["horizontalPlacement"]),
        _createVNode(_unref(VisAxis), {
          type: "x",
          numTicks: 20
        }),
        _createVNode(_unref(VisAxis), {
          type: "y",
          label: "Total Political Prisoners"
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}
}

})